var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkasSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.696,
    height: 29.959,
    viewBox: "0 0 15.696 29.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #f07e25;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.001,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.343,
    y1: 0.053,
    x2: 0.758,
    y2: 1.006,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fab720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f07e25"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9829",
    "data-name": "Group 9829",
    transform: "translate(406.696 -15466.244) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6478",
    "data-name": "Path 6478",
    className: "cls-1",
    d: "M130.175.158a1.276,1.276,0,0,1,1.275,1.277V4.125a1.275,1.275,0,1,1-2.551,0V1.368a1.263,1.263,0,0,1,1.275-1.21m0,10.42a1.276,1.276,0,0,1,1.275,1.277v2.689a1.275,1.275,0,1,1-2.551,0V11.855A1.276,1.276,0,0,1,130.175,10.578Zm0-3.832A1.277,1.277,0,1,1,128.9,8.024,1.235,1.235,0,0,1,130.175,6.746Zm2.937-.387a1.255,1.255,0,0,0,1.8,0l4.078-4.033a1.259,1.259,0,0,0,0-1.8,1.255,1.255,0,0,0-1.8,0l-4.078,4.033A1.231,1.231,0,0,0,133.112,6.36Zm0,3.26a1.255,1.255,0,0,1,1.8,0l4.078,4.033a1.271,1.271,0,0,1-1.8,1.8l-4.078-4.033A1.231,1.231,0,0,1,133.112,9.62Z",
    transform: "translate(15356.841 390.85)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9616",
    "data-name": "Group 9616",
    transform: "translate(15466.244 391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6482",
    "data-name": "Path 6482",
    className: "cls-2",
    d: "M20.281,0a7.848,7.848,0,0,1,7.853,7.865v.5a1.421,1.421,0,0,1-1.208.773,1.39,1.39,0,0,1-1.275-.891V7.865a5.3,5.3,0,1,0-10.605,0,5.158,5.158,0,0,0,1.342,3.512,1.482,1.482,0,0,1-.571,1.6,1.451,1.451,0,0,1-1.342.067A7.931,7.931,0,0,1,12.5,7.865,7.749,7.749,0,0,1,20.281,0",
    transform: "translate(-12.494 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7054",
    "data-name": "Path 7054",
    className: "cls-3",
    d: "M20.353,28.221A7.848,7.848,0,0,1,12.5,20.356v-.5a1.527,1.527,0,0,1,1.275-.706,1.39,1.39,0,0,1,1.275.891v.387a5.3,5.3,0,1,0,10.605,0,5.158,5.158,0,0,0-1.342-3.512,1.324,1.324,0,0,1,.571-1.6,1.186,1.186,0,0,1,1.275-.134,7.931,7.931,0,0,1,1.98,5.176,7.845,7.845,0,0,1-7.786,7.865",
    transform: "translate(-12.499 -12.525)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkasSupport);
export default __webpack_public_path__ + "static/media/OkasSupport.561195505159c8a945e6298561ccc786.svg";
export { ForwardRef as ReactComponent };